<div id="contacto" class="card-container col-12 row">
    <div class="col-12 col-lg-6 centrar separacion">
      <img src="assets/palomaComunicaciones.png" alt="image" height="500">
    </div>
    <div class="col-12 col-lg-6 centrar">
      <p class="granate"><img src="assets/telefono.png" alt="image" height="50"> <span class="naranja"> 655 13 94 80</span></p><br>
      <p class="granate"><img src="assets/localizacion.png" alt="image" height="50"><span class="naranja">C/ Narciso Serra, 33, 1ºA - 28007 Madrid</span> Metro Menéndez Pelayo o Metro Conde de Casal</p><br>
      <p class="granate"><img src="assets/mail.png" alt="image" height="50"> <span class="naranja"> info@psicopicto.com</span></p><br>
      <p class="granate"><a href="https://www.facebook.com/PalomaCallejaPsicologa"><img src="assets/facebook.png" alt="image" height="50"> <span class="naranja redes"> PalomaCallejaPsicologa</span></a></p><br>
      <p class="granate"><a href="https://join.skype.com/invite/hZzfNyp0o150"><img src="assets/skype.png" alt="image" height="50"> <span class="naranja"> psicopicto</span></a></p><br>
      <p class="granate"><a href="https://www.instagram.com/psicopicto.palomacalleja"><img src="assets/instagram.png" alt="image" height="50"> <span class="naranja redes"> psicopicto.palomacalleja</span></a></p>
    </div>

    <div class="col-12 col-lg-8 offset-lg-2 mb-5">
      <h2 class="titulo granate text-center">Colaboradores</h2>
        <div class="row">
        <mat-card class="col-12 col-lg-5">
          <mat-card-header>
            <mat-card-title>Isabel Ros Ajo</mat-card-title>
            <mat-card-subtitle>Psicólogo, Psicólogo infantil</mat-card-subtitle>
          </mat-card-header>
          <img mat-card-image src="assets/Isabel-Ros.jpg" alt="Isabel Ros Ajo">
          <mat-card-content>
            <p>
              Mi labor como psicóloga parte de la base de ayudar al paciente a un mayor conocimiento de sí mismo. Es de vital importancia conocer nuestros sistemas de apego porque actúan como balanza reguladora del estrés y determinan nuestra manera de interactuar con el mundo que nos rodea.
            </p>
          </mat-card-content>
          <mat-card-actions>
            <a mat-flat-button href="https://rospsicologia.com/" target="_blank">Ver web</a>
          </mat-card-actions>
        </mat-card>
        <mat-card class="col-12 col-lg-6 offset-lg-1">
          <mat-card-header>
            <mat-card-title>Irene Hernández Pascual</mat-card-title>
            <mat-card-subtitle>Psicóloga sanitaria</mat-card-subtitle>
          </mat-card-header>
          <img mat-card-image src="assets/irene-hernandez.png" alt="Irene Hernández Pascual">
          <mat-card-content>
            <p>
              Me hago cargo de la dificultad del camino, y el sufrimiento que pueden causar los problemas emocionales y psicológicos, por consiguiente, para mí es muy importante tratar con el mayor respeto, rigor y profesionalidad la situación de cada cliente.
            </p>
          </mat-card-content>
          <mat-card-actions>
            <a mat-flat-button href="https://psicoafectiva.com/" target="_blank">Ver web</a>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>

    <div class="col-12 col-lg-8 offset-lg-2">
      <h2 class="titulo granate text-center">Nuestra oficina</h2>
      <ngb-carousel>
        <ng-template ngbSlide>
          <div class="picsum-img-wrapper">
            <img src="assets/oficina1.png" class="imgCarousel">
          </div>
        </ng-template>
        <ng-template ngbSlide>
          <div class="picsum-img-wrapper">
            <img src="assets/oficina2.png" class="imgCarousel">
          </div>
        </ng-template>
        <ng-template ngbSlide>
          <div class="picsum-img-wrapper">
            <img src="assets/oficina3.png" class="imgCarousel">
          </div>
        </ng-template>
        <ng-template ngbSlide>
          <div class="picsum-img-wrapper">
            <img src="assets/oficina4.png" class="imgCarousel">
          </div>
        </ng-template>
        <ng-template ngbSlide>
          <div class="picsum-img-wrapper">
            <img src="assets/oficina5.png" class="imgCarousel">
          </div>
        </ng-template>
        <ng-template ngbSlide>
          <div class="picsum-img-wrapper">
            <img src="assets/oficina6.png" class="imgCarousel">
          </div>
        </ng-template>
      </ngb-carousel>
    </div>
</div>